import 'es6-object-assign/auto';

export function getDataLayer() {
	if ( !window.dataLayer ) {
		window.dataLayer = [];
	}

	return window.dataLayer;
}

export function triggerEvent( name = '', variables = {}) {
	const dataLayer = getDataLayer();

	const dataLayerVariables = Object.assign({}, variables, { event: name });

	dataLayer.push( dataLayerVariables );
}

export function trackFormView( formName = '' ) {
	triggerEvent( 'formView', { formName });
}

export function trackFormSubmit( formName = '' ) {
	triggerEvent( 'formSubmit', { formName });
}

export function trackPageview( url = '' ) {
	triggerEvent( 'pageview', { url });
}



// WEBPACK FOOTER //
// ./assets/_js/scripts/tag-manager.js